import { useEffect, useState } from 'react';
import * as msal from "@azure/msal-browser";
import { useSDK } from "@contentful/react-apps-toolkit";

const useMsalToken = () => {
    const [accessToken, setAccessToken] = useState(null);
    const sdk = useSDK();

    useEffect(() => {
        const init = async () => {
            const pca = new msal.PublicClientApplication({
                auth: {
                    clientId: sdk.parameters.installation.entraClientId,
                    authority: `https://login.microsoftonline.com/${sdk.parameters.installation.entraTenantId}`,
                },
                cache: {
                    cacheLocation: 'sessionStorage',
                    storeAuthStateInCookie: false
                }
            });

            await pca.initialize();

            // for debug
            // await pca.logoutPopup();
            // return;

            try {
                const accounts = pca.getAllAccounts();

                if (accounts.length === 0) {
                    // No accounts, need to login
                    const loginResponse = await pca.loginPopup({
                        scopes: [`api://${sdk.parameters.installation.entraClientId}/FanHub.API`],
                    });
                    pca.setActiveAccount(loginResponse.account);
                } else {
                    pca.setActiveAccount(accounts[0]);
                }

                // Attempt to acquire token silently
                const account = pca.getActiveAccount();
                const silentRequest = {
                    scopes: [`api://${sdk.parameters.installation.entraClientId}/FanHub.API`],
                    account,
                };

                try {
                    const response = await pca.acquireTokenSilent(silentRequest);
                    setAccessToken(response.accessToken);
                } catch (silentError) {
                    if (silentError instanceof msal.InteractionRequiredAuthError) {
                        try {
                            const response = await pca.acquireTokenPopup(silentRequest);
                            setAccessToken(response.accessToken);
                        } catch (popupError) {
                            if (popupError.errorCode === 'interaction_in_progress') {
                                console.warn('Interaction in progress, retrying after delay...');
                                setTimeout(init, 1000); // Retry after 1 second
                            } else {
                                console.error('Popup token acquisition failed:', popupError);
                            }
                        }
                    } else if (silentError.errorCode === 'interaction_in_progress') {
                        console.warn('Interaction in progress, retrying after delay...');
                        setTimeout(init, 1000); // Retry after 1 second
                    } else {
                        console.error('Silent token acquisition failed:', silentError);
                    }
                }
            } catch (error) {
                console.warn("Error during MSAL initialization or token acquisition", error);
                console.log("Retrying");
                if (error.errorCode === 'interaction_in_progress') {
                    console.warn('Interaction in progress, retrying after delay...');
                    setTimeout(init, 2000); // Retry after 2 second
                } else {
                    console.error('Popup token acquisition failed:', error);
                }
            }
        };

        init();
    }, [sdk.parameters.installation.entraClientId, sdk.parameters.installation.entraTenantId]);

    return accessToken;
};

export default useMsalToken;